import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Briefcase, BookOpen } from 'lucide-react';
import { facultyData } from '../../data/mock';

const FadeInSection = ({ children, className = '', delay = 0 }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay, ease: 'easeOut' }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const FacultySection = () => (
  <section className="py-24 bg-[rgb(17,17,19)] relative">
    <div className="max-w-[1200px] mx-auto px-6">
      <FadeInSection>
        <div className="text-center mb-16">
          <span className="text-[#F37021] text-sm font-semibold tracking-widest uppercase">Our Faculty</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-3 mb-4">Learn From the Best</h2>
          <p className="text-[rgb(161,161,170)] text-lg max-w-2xl mx-auto">
            Our handpicked faculty brings decades of combined experience and a passion for transforming student outcomes.
          </p>
        </div>
      </FadeInSection>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {facultyData.map((member, i) => (
          <FadeInSection key={i} delay={i * 0.08}>
            <div className="bg-[rgb(26,28,30)] border border-[rgba(255,255,255,0.1)] rounded-2xl overflow-hidden group hover:-translate-y-1 hover:border-[rgba(243,112,33,0.35)] transition-all duration-300">
              {/* Image */}
              <div className="relative h-64 overflow-hidden bg-[rgb(38,40,42)]">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[rgb(26,28,30)] via-transparent to-transparent" />
              </div>

              {/* Info */}
              <div className="p-6 -mt-8 relative">
                <h3 className="text-lg font-semibold text-white mb-1">{member.name}</h3>
                <p className="text-[#F37021] text-sm font-medium mb-3">{member.role}</p>
                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-[rgb(161,161,170)] text-sm">
                    <BookOpen size={14} className="text-[#F37021] flex-shrink-0" />
                    {member.subject}
                  </div>
                  <div className="flex items-center gap-2 text-[rgb(161,161,170)] text-sm">
                    <Briefcase size={14} className="text-[#F37021] flex-shrink-0" />
                    {member.experience} Experience
                  </div>
                </div>
              </div>
            </div>
          </FadeInSection>
        ))}
      </div>
    </div>
  </section>
);
